import { render, staticRenderFns } from "./auditRecord.vue?vue&type=template&id=bafcd70a&scoped=true"
import script from "./auditRecord.vue?vue&type=script&lang=js"
export * from "./auditRecord.vue?vue&type=script&lang=js"
import style0 from "./auditRecord.vue?vue&type=style&index=0&id=bafcd70a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bafcd70a",
  null
  
)

export default component.exports